import apiClient from "./client";
import type { AxiosRequestConfig } from "axios";
import type { RegisterRequest, User } from "@/types/api";

// Não há `login()` aqui: `POST /api/auth/login` não existe mais. A entrada é uma
// navegação de página inteira para `/api/auth/entra/login`, feita pelo `<a href>`
// de `pages/Login.tsx` — nunca por este cliente, porque o 302 vai para o
// `login.microsoftonline.com` e XHR não pode segui-lo.

export async function register(data: RegisterRequest): Promise<User> {
  const res = await apiClient.post<User>("/api/auth/register", data);
  return res.data;
}

export async function logout(): Promise<void> {
  await apiClient.post("/api/auth/logout");
}

export async function getMe(options?: { skipAuthRedirect?: boolean }): Promise<User> {
  const config: AxiosRequestConfig & { skipAuthRedirect?: boolean } = {
    skipAuthRedirect: options?.skipAuthRedirect,
  };
  const res = await apiClient.get<User>("/api/auth/me", config);
  return res.data;
}

// Aqui moravam o `changePassword` e o `ChangePasswordPayload`, do
// `POST /api/auth/password` (PR E). A rota saiu com o login por senha: não há
// mais credencial local a trocar, e `users.password_hash` foi dropada.

export interface UpdateMePayload {
  language?: string | null;
}

export async function updateMe(payload: UpdateMePayload): Promise<User> {
  const res = await apiClient.patch<User>("/api/auth/me", payload);
  return res.data;
}
